<template>
<svg data-svg-lvl-3="flyleafend-block-flyleafend" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs><mask id="lfe-m-f" x="0" y="0" width="500" height="430" fill="#ffffff"><path  d="M254.5093,347.9799H77.7677c-6.2787,0-11.3685-5.0899-11.3685-11.3685l-.0002-244.0896c0-6.2787,5.0899-11.3685,11.3685-11.3685h176.7418v266.8267Z"/></mask></defs><g id="Нахзац"> <path  :style="{ fill: params.flyleafendColor }"  class="lfe-c-2" d="M254.5093,347.9799H77.7677c-6.2787,0-11.3685-5.0899-11.3685-11.3685l-.0002-244.0896c0-6.2787,5.0899-11.3685,11.3685-11.3685h176.7418v266.8267Z"/> <image v-if="params.flyleafendImage" preserveAspectRatio="xMidYMid slice" width="500" height="430" :href="params.flyleafendImage" mask="url(#lfe-m-f)" /> </g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.lfe-c-1{opacity:.3;}.lfe-c-2{fill:#f4e8ce;}.lfe-c-2,.lfe-c-3{stroke-width:0px;}.lfe-c-3{fill:#64ff00;}</style>

